import { Photo, Thumbnail, ThumbnailsWrapper, Wrapper } from './PhotoGallery.styled';

import Image from 'next/image';
import type { ProductImageType } from '../../types/product';
import { useState } from 'react';

interface Props {
  photos: Array<ProductImageType>
};

export const PhotoGallery = ({ photos }: Props) => {
  const [photo, setPhoto] = useState(0);

  return (
    <Wrapper>
      <ThumbnailsWrapper>
        {photos.slice(0, 3).map((elem: ProductImageType, index: number) => (
          <Thumbnail key={elem.description} onClick={() => setPhoto(index)}>
            <Image
              src={elem.image}
              alt={elem.description}
              layout='fill'
              objectFit='contain'
            />
          </Thumbnail>
        ))}
      </ThumbnailsWrapper>
      <Photo>
        <Image
          src={photos[photo].image}
          alt={photos[photo].description}
          layout='fill'
          objectFit='contain'
        />
      </Photo>
    </Wrapper>
  );
};
